'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.experimentParameterSelector = exports.experimentTreatmentSelector = undefined;

var _laboratoryLib = require('laboratory-lib');

var experimentTreatmentSelector = exports.experimentTreatmentSelector = function experimentTreatmentSelector(_ref, treatmentKey) {
  var treatments = _ref.experimentTreatments.treatments;
  return (0, _laboratoryLib.getTreatment)(treatments, treatmentKey);
};

var experimentParameterSelector = exports.experimentParameterSelector = function experimentParameterSelector(state, treatmentKey, parameterKey) {
  var treatment = experimentTreatmentSelector(state, treatmentKey);
  return (0, _laboratoryLib.getParameter)(treatment, parameterKey);
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ExperimentTreatmentSelectors.js
// module id = 877
// module chunks = 4